export const newUI = `${window.location.origin}/2a-recon/createReport`;
